import React from "react";

import { PlayBackWhite, Video_Export } from "../../assets/images";
import DateTimeArrow from "../../assets/images/DateTimeArrow.svg";

import Calendar from "react-calendar";
import { subDays } from "date-fns";

import TimerCard from "./TimerCard";

const PopupCard = ({
  onSubmitBtn,
  dateChange,
  date,
  getDataFromChild,
  dateTwo,
  timeStringMain,
  mode,
  getDataFromChildTwo,
  setBlankDateTwo,
  setBlankDate,
  onExportBtn,
  exportCurrentVideoHide,
  videoExportDownload,
  activeSide,
  setActiveSide,
  dateChangeTwo,
}) => {
  return (
    <>
      {
        mode === "Playback" ? null
          :
          <>
            {
              !exportCurrentVideoHide
                ?
                <>
                  <div className="popup_link mt-0"
                    onClick={videoExportDownload}
                  >
                    <span>Download Current Video</span>
                  </div>
                  <div className="ORLine"></div>
                </>
                :
                null
            }
          </>
      }
      <div className="popupDiv">
        <div className="popup_card">
          <p className="popup_header">Select {activeSide === "start" ? "Start" : "End"} Date</p>
          <Calendar
            onChange={activeSide === "end" ? dateChangeTwo : dateChange}
            value={activeSide === "end" ? dateTwo : date}
            maxDate={new Date()}
            minDate={subDays(new Date(), 180)}
          />
        </div>
        <div className="popup_cardTimer">
          <div
            className={`popup_cardTimerRight ${activeSide === "start" ? "popup_cardTimerRightActive" : ""}`}
            onClick={() => setActiveSide && setActiveSide("start")}
          >
            <TimerCard
              dateFromParent={date}
              getDataFromChild={getDataFromChild}
              setBlankDate={setBlankDate}
              onFocus={() => setActiveSide && setActiveSide("start")}
            />
          </div>
          <div
            className="popup_cardTimerRightArrow"
          >
            <img src={DateTimeArrow} alt="DateTimeArrow" />
          </div>
          <div
            className={`popup_cardTimerRight ${activeSide === "end" ? "popup_cardTimerRightActive" : ""}`}
            onClick={() => setActiveSide && setActiveSide("end")}
          >
            <TimerCard
              dateFromParent={dateTwo}
              getDataFromChild={getDataFromChildTwo}
              setBlankDate={setBlankDateTwo}
              onFocus={() => setActiveSide && setActiveSide("end")}
            />
          </div>
        </div>
        <>
          {mode === "Playback" ? (
            <div className="popup_link" onClick={onSubmitBtn}>
              <img
                src={PlayBackWhite}
                className="playbackicon mr-2"
                alt="playback icon"
              />
              <span>Playback</span>
            </div>
          ) : (
            <div className="popup_link" onClick={onSubmitBtn}>
              <img
                src={Video_Export}
                className="playbackicon mr-2"
                alt="playback icon"
              />
              <span>Export</span>
            </div>
          )}
        </>
      </div>
    </>
  );
};

export default PopupCard;
